export default __webpack_public_path__ + "assets/img/juara3.911a2c3904196dc88b0128dac494328d.png";